export enum Languages {
    English = 'en-us',
    Norwegian = 'nb-no'
}
